<template>
  <div>
    <template v-if="memorialFundLogo && !isEditMode && !hideFund">
      <button
        v-if="hasPennyBridge"
        class="btn invisible"
        @click.prevent="toggleModal('donationInitial')"
      >
        <img :src="memorialFundLogo" alt="" class="fund-editor-logo" />
      </button>
      <a
        v-else-if="memorialFundUrl"
        class="btn invisible"
        target="_blank"
        :href="memorialFundUrl"
      >
        <img :src="memorialFundLogo" alt="" class="fund-editor-logo" />
      </a>
      <img v-else :src="memorialFundLogo" alt="" class="fund-editor-logo" />
    </template>
    <div
      v-else-if="isEditMode"
      class="obituary-single__hero-memorial-fund-edit"
    >
      <div class="memorial-fund-select__wrapper">
        <v-select
          :model-value="selectedFund"
          :options="availableFunds"
          :placeholder="texts.fundPlaceholder"
          :searchable="true"
          :clearable="true"
          :disabled="!availableFunds.length"
          :class="{ disabled: !availableFunds.length }"
          @update:model-value="setSelected"
        />
        <span class="memorial-fund-select__icon-wrapper">
          <Loader :loading="isSavingMemorialFund" />
          <div class="memorial-fund-select__icon">
            <svg v-if="!isSavingMemorialFund && selectedFund" class="icon">
              <use href="#check" />
            </svg>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import vSelect from 'vue-select';
import Loader from 'Components/loader/Loader.vue';

export default {
  name: 'MemorialFund',
  components: {
    vSelect,
    Loader,
  },
  data() {
    const memorialFund = JSON.parse(this.$mountEl.dataset.memorialFund);
    const hideFund = !!this.$mountEl.dataset.hideFund;

    if (memorialFund) {
      this.setState({ memorialFundLogo: memorialFund.image });
      return {
        selectedFund: {
          id: memorialFund.term_id,
          label: memorialFund.name,
        },
        hideFund,
        texts: lavendlaObituary.creator,
        memorialFundUrl: memorialFund.url,
        hasPennyBridge: !!memorialFund.pennybridge_id,
      };
    }

    return {
      selectedFund: null,
      hideFund,
      texts: lavendlaObituary.creator,
      memorialFundUrl: null,
      hasPennyBridge: false,
    };
  },
  computed: {
    ...mapState('creator', [
      'isEditMode',
      'memorialFund',
      'isSavingMemorialFund',
      'availableFunds',
      'memorialFundLogo',
    ]),
  },
  mounted() {
    this.getAvailableFunds();
  },
  methods: {
    ...mapMutations('creator', ['setState']),
    ...mapActions('creator', ['getAvailableFunds', 'saveMemorialFund']),
    ...mapActions('createComment', ['toggleModal']),
    setSelected(fund) {
      this.selectedFund = fund;
      this.saveMemorialFund(this.selectedFund);
    },
    save() {
      this.saveMemorialFund(this.selectedFund);
    },
  },
};
</script>
